export default __webpack_public_path__ + "static/Badges1-198d58e854c5e261146d4bf633632a75.svg";